module.exports = __webpack_public_path__ + "e0f66ee0334b7207b2383cb0f69ec4c9.png";